import AutomaticInsights from '../../assets/automaticInsights.png';
import EmotionalMapping from '../../assets/emotionMapping.png';
import SentimentAnalysis from '../../assets/sentimentAnalysis.png';
const InsightsSection = () => {
  const insightsData = [
    {
      id: 1,
      iconSrc: EmotionalMapping,
      title: 'Emotion Mapping',
      description:
        '13 distinct emotions mapped out. Ready to provide an indepth analysis. More Emotions, more precision.',
    },
    {
      id: 2,

      iconSrc: SentimentAnalysis,
      title: 'Sentiment Analysis',
      description:
        'Built in sentiment analysis adds an extra layer of emotional intelligence.',
    },
    {
      id: 3,
      iconSrc: AutomaticInsights,
      title: 'Automatic Insights',
      description:
        'Save time, cut costs, and unlock instant value with AI powered emotional insights.',
    },
  ];

  return (
    <div className="insights-section-container">
      <p className="insights-intro-text">
        By monitoring facial movements we highlight aspects of the interactions
        that cause changes in emotional response, providing unique insights so
        you can better understand customers' feelings and sentiment during the
        engagement.
      </p>

      <div className="insights-cards-wrapper">
        {insightsData.map((insight) => (
          <div className="insight-card" key={insight.id}>
            <div className="insight-card-icon">
              <img src={insight.iconSrc} alt={`${insight.title} Icon`} />
            </div>
            <h3 className="insight-card-title">{insight.title}</h3>
            <p className="insight-card-description">{insight.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsSection;
